import { EVENT_READY, EVENT_UPDATE_VIEW } from '../../constants/event';
import Base from './base';

class ComponentBase extends Base {
  protected elementRef: WeakRef<HTMLElement>;

  protected isDestroyed = false;
  protected onReadyBinding: (() => void) | null = null;
  protected onUpdateViewBinding: (() => void) | null = null;

  constructor(element: HTMLElement) {
    super();
    if (!element) {
      throw new Error('Element is required');
    }

    this.elementRef = new WeakRef(element);
    this.onReadyBinding = this.onReady.bind(this);
    this.onUpdateViewBinding = this.onUpdateView.bind(this);
    
    // EVENT_READYが既に発火済みかチェック
    if (document.body.classList.contains('is-loaded')) {
      // 既に発火済みの場合はすぐにonReadyを呼び出す
      setTimeout(() => {
        if (!this.isDestroyed) {
          this.onReady();
        }
      }, 0);
    } else {
      // まだ発火していない場合はイベントを待つ
      if (this.onReadyBinding) {
        document.addEventListener(EVENT_READY, this.onReadyBinding, { once: true });
      }
    }
    
    if (this.onUpdateViewBinding) {
      document.addEventListener(EVENT_UPDATE_VIEW, this.onUpdateViewBinding);
    }
  }

  public get element(): HTMLElement {
    const element = this.elementRef.deref();
    if (!element) {
      throw new Error('Element has been garbage collected');
    }

    return element;
  }

  protected onUpdateView(): void {
    if (!this.element?.isConnected) {
      this.destroy();
    }
  }

  protected init(): void {}

  protected destroy() {
    if (this.isDestroyed) {
      return;
    }

    this.isDestroyed = true;
    this.destroyEventListeners();
    this.onDestroy();
  }

  protected onDestroy(): void {}

  protected destroyEventListeners(): void {
    if (this.onUpdateViewBinding) {
      document.removeEventListener(EVENT_UPDATE_VIEW, this.onUpdateViewBinding);
    }
  }

  protected onReady(): void {}
}

export default ComponentBase;
